<template>
    <div class="project-list">
      <div class="module-header v-center space-between" >
        <h1 class="module-name v-center">
          Projects
        </h1>
        <div class="v-center add-btn">
          <button v-if="isTenantAdminOrCollaborator" @click="openDrawer" class="btn">
            + Add Project
          </button>
        </div>
      </div>
      <div class="filter-container v-center">
        <!-- <div class="toggle-btn">
          <button :class="{ active: selectedTab === 'active' }" @click="selectedTab = 'active'" class="toggle-option">Active</button>
          <button :class="{ active: selectedTab === 'inactive' }" @click="selectedTab = 'inactive'" class="toggle-option">Inactive</button>
        </div> -->
        <div class="filter-right">
          <div>
            <label for="">Sort By</label>
            <select v-model="selectedSort" class="sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
            </select>
          </div>
          <div class="input-group search ml-4">
            <input
            class="input-search"
            v-model="searchKeyword"
            @input="updateOnSearch"
            type="text"
            placeholder="Search"
            />
          </div>
        </div>
      </div>
      <div class="project-list-container my-5">
        <copy-project-table
          :projectList="getSearchResult"
          :perPage="perPage"
          :pageNumber="pageNumber"
          :showHeader="true"
          :loading="loading"
          :collaborator="collaborator"
          @delete="deleteProject"
          @edit="editProject"
          @retry="retryImport"
        ></copy-project-table>
        <div class="v-center space-between mt-3">
        <pagination2 :length="totalcount" :pageNumber="pageNumber" :perPage="perPage"
            @selectPage="selectPage"
          class="mt-3 mx-2"
        />
        <span class="mt-5">Total Projects : &nbsp; <b class="mr-5"> {{ totalcount }}</b></span>
        </div>
      </div>
      <div v-if="showProjectAction" class="drawer" :class="drawer ? 'open' : 'close'">
        <div class="project-form-container">
          <project-form
            ref="projectForm"
            :isUpdate="openId !== null"
            :drawer="true"
            @cancel="closeDrawer"
            @save="saveProject"
            @update="updateProject"
            :closeOnOutsideClick="true"
            :buttonDisabled="buttonDisabled"
          ></project-form>
        </div>
      </div>
    </div>
  </template>
<script>
import {
  GetAllProjectsList,
  CreateNewProject,
  DeleteProjectById,
  UpdateProjectById
} from '@/api'
import copyProjectTable from '../../components/common/copyProjectTable.vue'
import ProjectForm from '@/components/manage/projectForm.vue'
import { arraySearch } from '@/utils/array'
// import Pagination from '../../components/common/pagination.vue'
import Pagination2 from '../../components/common/pagination2.vue'
import { mapGetters } from 'vuex'
import { copyProjectPlan } from '../../api/apis/projectPlanner'
import { startGlobalCursorLoader, stopGlobalCursorLoader } from '@/utils/globalCursorLoader'
import { alert, success, warning } from '@/plugins/notification'
import { debounce } from '@/utils/debounce'

export default {
  name: 'Projects',
  components: { copyProjectTable, ProjectForm, Pagination2 },
  data () {
    return {
      length: 50,
      first: 1,
      second: 10,
      selectedTab: 'active',
      selectedSort: '1',
      drawer: false,
      openId: null,
      searchKeyword: '',
      projectList: [],
      pageNumber: 1,
      perPage: 10,
      loading: false,
      buttonDisabled: false, // this for disabling update button  of project updation
      updateOnSearch: null,
      totalcount: 0

    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'collaborator']),
    getSearchResult () {
      return arraySearch(this.projectList, this.searchKeyword, { fieldsToSearch: ['name'] })
    },
    isTenantAdminOrCollaborator () {
      return (
        this.user.tenantLevelRole === 'ADMIN' && !this.collaborator)
    },
    showProjectAction () {
      return (
        this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'EDITOR' ||
            this.user.tenantLevelRole === 'COLLABORATOR'
      )
    }
  },
  watch: {
    selectedSort (value) {
      if (value === '0') return
      this.getAllProjectsList()
    },
    selectedTab () {
      this.getAllProjectsList()
    }
  },
  methods: {
    retryImport (row) {
      startGlobalCursorLoader()
      copyProjectPlan({ importId: row.project_imports[0]?.id }).then((res) => {
        success('Retry initiated successfully')
        this.getAllProjectsList()
      }).catch(err => {
        alert(err?.message ?? 'Something went wrong')
      }).finally(() => {
        stopGlobalCursorLoader()
      })
    },
    selectPage (pageNumber) {
      this.pageNumber = pageNumber
    },
    openDrawer () {
      this.drawer = true
    },
    closeDrawer () {
      this.$refs.projectForm.resetForm()
      this.openId = null
      this.drawer = false
    },
    editProject (obj) {
      this.openId = obj.id
      this.$refs.projectForm.name = obj.name
      this.$refs.projectForm.latitude = obj.latitude
      this.$refs.projectForm.longitude = obj.longitude
      this.$refs.projectForm.selectedTenant = obj.associated_tenant?.id
      this.$refs.projectForm.startDate = obj.planned_start_date
      this.$refs.projectForm.endDate = obj.planned_end_date
      this.$refs.projectForm.cost = obj.project_cost
      this.$refs.projectForm.revenue = obj.project_revenue
      this.$refs.projectForm.address = obj.address?.address
      this.$refs.projectForm.state = obj.address?.state
      this.$refs.projectForm.city = obj.address?.city
      this.$refs.projectForm.pincode = obj.address?.pincode
      this.openDrawer()
    },
    async saveProject (obj) {
      this.buttonDisabled = true
      const data = {
        name: obj.name.trim(),
        planned_start_date: obj.planned_start_date,
        planned_end_date: obj.planned_end_date,
        project_cost: obj.project_cost,
        project_revenue: obj.project_revenue,
        address: obj.address,
        location:
            obj.latitude && obj.longitude
              ? `(${obj.latitude}, ${obj.longitude})`
              : null
      }
      if (obj.copyProjectPlan) {
        data.project_imports = {
          data: {
            name: 'COPY PROJECT PLAN',
            type: 5,
            copy_project_id: obj.copyProjectPlan,
            metadata: {
              assignees: obj.assignees,
              documents: obj.documents,
              doc_task_assoc: obj.docTaskAssoc,
              boms: obj.boms,
              bom_task_assoc: obj.bomTaskAssoc
            }
          }
        }
      }
      let message = ''
      try {
        const res = await CreateNewProject(data)
        message = 'Project Created'
        const importId = res?.insert_core_projects_one?.project_imports?.[0]?.id
        if (obj.copyProjectPlan) {
          const copyProjectRes = await copyProjectPlan({ importId })
          console.log('copyProjectRes', copyProjectRes)
        }
        this.getAllProjectsList()
        this.closeDrawer()
        success(message + ' successfully.')
        return
      } catch (err) {
        if (err?.message?.includes('Uniqueness violation')) {
          return this.$notify.alert('Project name already exists')
        }

        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Something went wrong'
        let alertType = alert
        if (message.includes('Project Created')) {
          alertType = warning
        }
        alertType(errorMessage)
      } finally {
        this.closeDrawer()
        this.buttonDisabled = false
      }
    },
    deleteProject (obj) {
      DeleteProjectById({ id: obj.id }).then((res) => {
        this.getAllProjectsList()
        const maxPage = Math.ceil((this.totalcount - 1) / this.perPage) || 1
        if (this.pageNumber > maxPage) {
          this.pageNumber = maxPage
        }
        this.$notify.success('Project Deleted Successfully')
      })
    },
    updateProject (obj) {
      this.buttonDisabled = true
      const data = {
        name: obj.name?.trim(),
        planned_start_date: obj.planned_start_date,
        planned_end_date: obj.planned_end_date,
        project_cost: obj.project_cost,
        project_revenue: obj.project_revenue,
        address: obj.address,
        location:
            obj.latitude && obj.longitude
              ? `(${obj.latitude}, ${obj.longitude})`
              : null
      }
      UpdateProjectById({ id: this.openId, data }).then((res) => {
        this.getAllProjectsList()
        this.closeDrawer()
        this.$notify.success('Project Updated Successfully')
        this.buttonDisabled = false
      }).catch(err => {
        this.buttonDisabled = false
        if (err?.message?.includes('Uniqueness violation')) {
          return this.$notify.alert('Project name already exists')
        }
        this.$notify.alert(err?.message ?? 'Something went wrong')
      })
    },
    getAllProjectsList () {
      this.loading = true
      const skipImports = false
      GetAllProjectsList(this.selectedSort, this.selectedTab, this.searchKeyword, skipImports)
        .then((res) => {
          //  the same api call is used to fetching project data in vuex project list as well as project list in project module , no need to get update  project list in vuex if there is a search keyword , which is comming from Project lsit from project module
          if (!this.searchKeyword) {
            this.$store.commit('setTenantProjectList', res?.core_projects)
          }
          this.loading = false
          this.totalcount = res.core_projects_aggregate.aggregate.count
          this.projectList = res.core_projects?.map((item) => {
            const location = item.location
              ? item.location.replace('(', '').replace(')', '').split(',')
              : []
            return {
              ...item,
              latitude: location[0] || '',
              longitude: location[1] || ''
            }
          })
        })
        .catch((error) => {
          console.log(error)
          alert('Something went wrong')
          this.loading = false
        })
    }
  },
  created () {
    this.updateOnSearch = debounce(() => {
      this.pageNumber = 1
      this.getAllProjectsList()
    }, 500)
    this.getAllProjectsList()
  }
}
</script>
<style lang="scss" scoped>
.project-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  padding-left: 10px;
  .module-header {
    flex-shrink: 0;
  }
  .filter-container {
    flex-shrink: 0;
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 2rem;
.filter-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
    .sort {
    height: 2em;
    width: 10rem;
    margin: 0 0 0 10px;
    font-size: var(--text-base);
    background-color: var(--brand-light-color);
    line-height: 1;
    border: 1px solid var(--brand-color);
    border-radius: 4px;
    padding: 4px 12px;
    }
  .input-search {
    height: fit-content;
  }
  }
  .project-list-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;
    margin-bottom: 10px;
    ::v-deep .copy-dtx-table-wrapper {
      height: 100%;
    }
  }
.project-form-container {
  height: 100%;
  }
  .drawer {
    top: 60px;
    overflow-y: unset;
  }
  @media screen and (max-width: 1366px) {
  .add-btn .btn {
    font-size: var(--text-base);
    padding: 6px 12px;
  }
}

@media screen and (max-width: 1200px) {
  .add-btn .btn {
    font-size: var(--text-m);
    padding: 5px 10px;
  }
}

@media screen and (max-width: 1024px) {
  .add-btn .btn {
    font-size: var(--text-s);
    padding: 4px 8px;
  }
}
}
</style>
